import CRM from '../../pages/CRM';

interface CrmEmbeddedOpportunityModalProps {
  opportunityId: number;
  onClose: () => void;
  onUpdated?: () => void;
}

/** Hosts the full CRM opportunity drawer on top of the control centre (no route change). */
export default function CrmEmbeddedOpportunityModal({
  opportunityId,
  onClose,
  onUpdated,
}: CrmEmbeddedOpportunityModalProps) {
  return (
    <CRM
      embedOpportunityId={opportunityId}
      hidePageChrome
      onEmbedClose={onClose}
      onEmbedOpportunityChange={onUpdated}
    />
  );
}
